import { Purchase, TicketType } from "types";

export const hasOtaTicket = (purchase: Purchase) => {
    return purchase.items?.some((item) => item.tickets?.some((ticket) => ticket.type === TicketType.OTA));
};
